(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ResourceLink', ResourceLink);

    ResourceLink.$inject = ['$resource', 'DateUtils'];

    function ResourceLink ($resource, DateUtils) {
        var resourceUrl =  'resource/round/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
